import { render, staticRenderFns } from "./NewContentDepthModal.vue?vue&type=template&id=44986358&lang=pug&"
import script from "./NewContentDepthModal.vue?vue&type=script&lang=js&"
export * from "./NewContentDepthModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports